import DiscontinuedPage from "./DiscontinuedPage";

export default DiscontinuedPage;
